import { FUTURO_TYPEFACES as F } from '@ordermentum/ui-shared/foundations/font';
import { genThemedStyled } from '@ordermentum/ui-shared/utilities/theme';
import { ColorCodes } from '@ordermentum/ui-shared/foundations/color';
import S from '@ordermentum/ui-shared/foundations/size';

type themeStyles = {
  textLinkColor: ColorCodes;
};

const ThemeStyled = genThemedStyled<themeStyles>();

export const Container = ThemeStyled.div({
  marginTop: S.S,
});

export const Text = ThemeStyled.div(
  p => ({
    marginBlock: 0,
    textAlign: 'center',
    wordBreak: 'break-word',
  }),
  F.BODY_SMALL
);

export const TextLink = ThemeStyled.a(
  p => ({
    display: 'inline',
    color: p.theme.textLinkColor,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  }),
  F.LABEL_SMALL_BOLD
);
